import { Button, Typography, Divider, Link } from '@material-ui/core'
import React from 'react'
import { Topic as ITopic } from '../../../../types/academy'
import { makeStyles } from '@material-ui/core/styles'
import ArrowForwardIcon from '@material-ui/icons/ArrowForward'

const useStyles = makeStyles((theme) => ({
  root: {},
  courseTitle: {
    fontSize: '1rem',
    fontWeight: 'bold',
    display: 'flex',
  },
  subTitle: {
    fontSize: '.8rem',
    fontWeight: 'bold',
    color: 'rgba(199, 195, 205, 1)',
  },
  lessonsSection: {
    margin: '2rem 0',
  },

  chip: {
    borderRadius: '4px',
    margin: '.8rem 0',
    fontSize: '.8rem',
    textTransform: 'unset',
    fontFamily: theme.typography.fontFamily,
    display: 'block',
    textAlign: 'left',
    letterSpacing: 'unset',
    padding: '.5rem',
    background: theme.palette.grey[300],
    fontWeight: 600,
  },
  activeChip: {
    background: theme.palette.primary.main,
    color: 'white',
  },
  courseTitleLink: {
    color: 'black',
  },
}))

interface Props {
  topics: ITopic[]
  currentTopic: string
}

export default function CourseSideBar({ topics, currentTopic }: Props): JSX.Element {
  const classes = useStyles({})
  return (
    <div>
      <div>
        <Link href="/topics" className={classes.courseTitleLink}>
          <Typography variant="h6" className={classes.courseTitle}>
            All Topics <ArrowForwardIcon />
          </Typography>
        </Link>
        <Divider />
      </div>
      <div className={classes.lessonsSection}>
        {topics.map((topic) => (
          <Button
            disableElevation
            key={topic.slug}
            className={`${classes.chip} ${topic.slug === currentTopic && classes.activeChip}`}
            href={`/lesson?topic=${topic.slug}`}
          >
            {topic.title}
          </Button>
        ))}
      </div>
    </div>
  )
}
